namespace Pages {
    export class SystemPage {
        private readonly _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }

        async reset() {
            //await this._repository.local().destroy();
            return new PageActionResult(new PageActionReload());
        }
    }
}